import { render, staticRenderFns } from "./GerenciarFaltasJustificadasPage.vue?vue&type=template&id=322dfc8c&scoped=true"
import script from "./GerenciarFaltasJustificadasPage.vue?vue&type=script&lang=js"
export * from "./GerenciarFaltasJustificadasPage.vue?vue&type=script&lang=js"
import style0 from "./GerenciarFaltasJustificadasPage.vue?vue&type=style&index=0&id=322dfc8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322dfc8c",
  null
  
)

export default component.exports